
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { ListViewModel } from '@/definitions/view-models';
import { autoUpdateHelper } from '@/api/common/auto-update-helper';
import { Line } from '@/api/models/Line';
import { LinesFilter } from '@/api/models/LinesFilter';
import { aclModule } from '@/store/acl';
import { dataAssetsModule } from '@/store/application/data.assets.module';
import { PagePaths } from '@/store/application/page.definitions';
import { pageModule } from '@/store/application/page.module';
import { multisidebarModule } from '@/store/multisidebar';
import { MultisidebarItemTypes } from '@/store/multisidebar/types';
import NBaseBar from '@/uikit/bars/NBaseBar.vue';
import NButton from '@/uikit/buttons/NButton.vue';
import NButtonGroup from '@/uikit/buttons/NButtonGroup.vue';
import { IFormLayoutItem } from '@/uikit/forms/NForm.vue';
import EntityBlank from '@/components/common/EntityBlank.vue';
import FilterSection from '@/components/common/filter/FilterSection.vue';
import SortDropdown from '@/components/common/SortDropdown.vue';
import Statistics from '@/components/common/Statistics.vue';
import { getLineFilters } from '@/pages/lines/LineFilters';
import LinesTable from '@/pages/lines/LinesTable.vue';
import ListPage from '@/pages/ListPage.vue';
import {PageViewModel} from "@/store/application/page.view.model";
import {cloneDeep} from "lodash";
import {reactive} from "vue";

@Options({
  name: 'LinesPage',
  components: {
    EntityBlank,
    FilterSection,
    LinesTable,
    ListPage,
    NBaseBar,
    NButton,
    NButtonGroup,
    SortDropdown,
    Statistics
  }
})
export default class LinesPage extends Vue {
  @Prop({ type: String, required: true })
  tab!: string;

  pageVM: PageViewModel<any, any> = new PageViewModel<any, any>({ tab: String(Math.random()), path: PagePaths.Lines });

  get smallFilterLayout(): IFormLayoutItem[] {
    return getLineFilters({ small: true });
  }

  get bigFilterLayout(): IFormLayoutItem[] {
    return getLineFilters({ small: false });
  }

  get selectedItemIds(): number[] {
    return this.sidebarModule.items.filter((v) => v.type === MultisidebarItemTypes.Lines).map((v) => v.model.item.id);
  }

  get sidebarModule() {
    return multisidebarModule;
  }

  get module(): ListViewModel<any, any> {
    return this.pageVM.module as ListViewModel<any, any>;
  }

  get state() {
    return this.pageVM.state;
  }

  get modelAcl() {
    this.module.aclModelName = 'line';
    return aclModule.getModelAcl(this.module);
  }

  get sortTypes(): any[] {
    return dataAssetsModule.getSortTypes({ created_date: true }).map((v) => ({ ...v, label: this.$t(v.i18n_label) }));
  }

  get emptyItems() {
    return !(this.module.items.length || this.module.filter.hasChanges);
  }

  @Watch('module.filter.current', { deep: true })
  changeFilterHandler(v: any, p: any) {
    if (v?.page !== p.page) return;
    if (v?.limit !== p.limit) return;
    this.module.debouncedGet();
    this.state.filter = this.module.filter.currentClean;
  }

  handleCreate() {
    this.sidebarModule.addNewItemByType(MultisidebarItemTypes.Lines);
  }

  created() {
    const route = cloneDeep(this.$route);
    route.query.tab = this.tab;
    this.pageVM = reactive(pageModule.getPageViewModel(route)) as PageViewModel<any, any>;
  }

  mounted() {
    autoUpdateHelper.addListInstance(this.module);
  }
}
